<app-reports
  title="Client Referral Check Reports"
  [reportsUrl]="reportsUrl" />
